module.exports = __webpack_public_path__ + "static/media/course.6cd3687c.svg";